import React, { useState, useCallback } from "react";
import ReactTable from "components/ReactTable/ReactTable.tsx";
import { useHistory, useLocation } from "react-router-dom";
import { fetchDataJson } from "core/FetchApi";
import { useUrlFilters } from "hooks/useUrlFilters";

const Table = ({ columns, pathroot, url, filters, orderBy, hideDataUntilFilter, saveFilters = true }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const { initialFilters, handleFiltersChange } = saveFilters
    ? useUrlFilters()
    : { initialFilters: undefined, handleFiltersChange: undefined };

  const callApi = async ({ pageSize, pageIndex }) => {
    try {
      let queryString = `?size=${pageSize}&page=${pageIndex + 1}`;

      for (const key in filters) {
        queryString += `&filter[${key}]=${filters[key]}`;
      }

      if(orderBy){
        queryString += `&orderBy=${orderBy.field}&orderDescending=${orderBy.desc}`;
      }

      const responseData = await fetchDataJson(url + queryString, {
        method: "GET",
      });

      setData(responseData.model);

      setPageCount(responseData.count);
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const fetchData = useCallback(({ pageSize, pageIndex }) => {
    callApi({ pageSize, pageIndex });
  }, []);

  return (
    <ReactTable
      data={data}
      columns={columns}
      fetchData={fetchData}
      pageCount={pageCount}
      defaultPageSize={100}
      hideDataUntilFilter={hideDataUntilFilter}
      initialFilters={initialFilters}
      onFiltersChange={handleFiltersChange}
      getTrProps={(rowData) => {
        return {
          onClick: (_, handleOriginal) => {
            if (rowData) history.push(`${pathroot ?? pathname}/${rowData.id}`, { showBackButton: true });

            if (handleOriginal) handleOriginal();
          },
        };
      }}
    />
  );
};

export default Table;
